<template>
  <div>
    <header-item />
    <list-item />
    <gotop />
  </div>
</template>

<script>
import Gotop from '../common/components/Gotop';
import pageExpose from '../common/mixins/pageExpose';
import HeaderItem from './components/HeaderItem';
import ListItem from './components/ListItem';

export default {
  components: {
    HeaderItem,
    ListItem,
    Gotop,
  },
  mixins: [pageExpose],
  asyncData({ context, store, route }) {
    return store
      .dispatch('qlist/prefetchData', { context, route })
      .catch(err => console.log('[PREFETCH_QLIST_ERROR]', err));
  },
};
</script>
